import { Paper, TextField, WithStyles } from '@material-ui/core';
import { createStyles, withStyles } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { push } from 'connected-react-router';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import QuickModeCard from 'src/components/QuickModeCard';
import { IRootState } from 'src/reducers';
import { IMessage } from '../actions/message';
import * as Actions from '../actions/quickModeContens';
import MessageDialog from '../components/MessageDialog';
import i18n from '../resources/i18n';
import ScenarioFactory from '../scenario/QuickModeContentsScenarioFactory';
import InputCheck from '../utils/InputCheck';
import { isMobile } from '../utils/MobileCheck';
import { Routes, Screens } from '../utils/Routes';
const styles = (theme: Theme) =>
	createStyles({
		container: {
			display: 'flex',
			flexWrap: 'wrap',
			height: '100%',
			justifyContent: 'center',
		},
		courseNameInput: {
			width: '90%',
		},
		paper: {
			display: 'flex',
			flexWrap: 'wrap',
			justifyContent: 'center',
			maxWidth: '1000px',
			minWidth: '300px',
			padding: '10px',
			width: '51%',
		},
		root: {
			flexGrow: 1,
			padding: 10,
			wordBreak: 'break-all',
		},
	});

interface IState {
	courseName: string;
	openMessageDialog: boolean;
	messages: IMessage[];
}

class QuickModeContentsCreate extends React.Component<IProps, IState> {
	public constructor(props: IProps) {
		super(props);
		this.state = {
			courseName: '',
			messages: [],
			openMessageDialog: false,
		};
		this.changeCourseName = this.changeCourseName.bind(this);
		this.errorMessageDialogClose = this.errorMessageDialogClose.bind(this);
	}

	public componentDidMount() {
		const courseName = '新規コース';
		this.setState({
			courseName,
		});
		this.props.saveCourseName(courseName);
	}

	public render() {
		const { classes } = this.props;
		const text1 = i18n.t('QuickModeContentsCreate_0000');
		const text2 = i18n.t('QuickModeContentsCreate_0001');
		const text3 = i18n.t('QuickModeContentsCreate_0002');
		return (
			<div className={classes.root}>
				<div className={classes.container}>
					<Paper className={classes.paper}>
						<TextField
							className={classes.courseNameInput}
							label={i18n.t('QuickModeContentsCreate_0003')}
							value={this.state.courseName}
							onChange={this.changeCourseName}
						/>
					</Paper>
				</div>
				<div className={classes.container}>
					<QuickModeCard
						title={i18n.t('QuickModeContentsCreate_0004')}
						ImageSrc={require('../images/Text.png')}
						text={text1}
						buttonName={i18n.t('QuickModeContentsCreate_0007')}
						onClick={this.handleOnclick(1)}
					/>
					{!isMobile() && (
						<>
							<QuickModeCard
								title={i18n.t('QuickModeContentsCreate_0005')}
								ImageSrc={require('../images/Test.png')}
								text={text2}
								buttonName={i18n.t(
									'QuickModeContentsCreate_0007'
								)}
								onClick={this.handleOnclick(2)}
							/>
							<QuickModeCard
								title={i18n.t('QuickModeContentsCreate_0006')}
								ImageSrc={require('../images/Test+Text.png')}
								text={text3}
								buttonName={i18n.t(
									'QuickModeContentsCreate_0007'
								)}
								onClick={this.handleOnclick(3)}
							/>
						</>
					)}
				</div>
				<MessageDialog
					open={this.state.openMessageDialog}
					showCancelButton={false}
					title={i18n.t('QuickModeContentsCreate_0008')}
					contents={this.state.messages}
					onClose={this.errorMessageDialogClose}
					onClickOk={this.errorMessageDialogClose}
				/>
			</div>
		);
	}

	protected errorMessageDialogClose() {
		this.setState({ openMessageDialog: false, messages: [] });
	}

	protected changeCourseName(event: React.ChangeEvent<HTMLInputElement>) {
		const target = event.target as HTMLInputElement;
		const courseName = target.value;
		this.setState({
			courseName,
		});
	}
	private handleOnclick = (num: number) => () => {
		const messages: IMessage[] = [];
		if (
			!this.state.courseName ||
			this.state.courseName.trim().length === 0
		) {
			// コース名を設定してください。
			const message: IMessage = {
				content: 'CHK_E_0087',
				replacements: [i18n.t('QuickModeContentsCreate_0009')],
			};
			messages.push(message);
			this.setState({
				messages,
				openMessageDialog: true,
			});
			return;
		}
		if (InputCheck.chkStringMaxLength(this.state.courseName.trim(), 256)) {
			// コース名の長さは256文字以下です。CHK_E_0004
			const message: IMessage = {
				content: 'CHK_E_0004',
				replacements: [i18n.t('QuickModeContentsCreate_0009'), '256'],
			};
			messages.push(message);
			this.setState({
				messages,
				openMessageDialog: true,
			});
			return;
		}
		this.props.saveCourseName(this.state.courseName.trim());

		this.props.createFetchCourseFolder(this.props.token);
		const to = Routes.getPath(Screens.QUICK_MODE_TEXT_TEST_CREATE);
		switch (num) {
			case 1:
				this.props.saveViewItem(['TEXT']);
				break;
			case 2:
				this.props.saveViewItem(['TEST']);
				break;
			case 3:
				this.props.saveViewItem(['TEXT', 'TEST']);
				break;
			default:
				break;
		}
		this.props.pushHistoryState(to, {
			initFlg: false,
		});
	};
}

const mapStateToProps = (state: IRootState) => ({
	courseName: state.quickModeContents.courseName,
	token: state.session.token,
	userAttr: state.session.userAttr,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	createFetchCourseFolder: (token: string) => {
		const s = ScenarioFactory.createFetchCourseFolder(dispatch, token);
		s.run({});
	},
	pushHistory: (path: string) => dispatch(push(path)),
	pushHistoryState: (path: string, state: any) =>
		dispatch(
			push({
				pathname: path,
				state,
			})
		),
	saveCourseName: (courseName: string) => {
		dispatch(Actions.setCourseName({ courseName }));
	},
	saveViewItem: (viewItem: string[]) => {
		dispatch(Actions.setViewItem({ viewItem }));
	},
});

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles>;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(QuickModeContentsCreate);

const Styled = withStyles(styles)(Connected);

export default Styled;



// WEBPACK FOOTER //
// ./src/containers/QuickModeContentsCreate.tsx